import React from 'react';
export function SiteFooter() {
  return <footer className="w-full bg-pitch" data-id="element-171" data-mp="3rjvz5hlqcyja">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center" data-id="element-172" data-mp="1bettc3zu76jg">
        <p className="text-lg font-extrabold text-white" data-id="element-173" data-mp="1bh6kn7rhit96">Método Fútbol Digital</p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-body" data-id="element-174" data-mp="1fh6wqlr42sd2">
          El método para que papás y mamás en México acompañen, protejan y planifiquen la carrera
          futbolística de sus hijos e hijas en fuerzas básicas.
        </p>
        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-body" data-id="element-175" data-mp="rql15tyan0jy">
          <li data-id="element-176" data-mp="wpxn8chcc3lh">
            <a href="mailto:solucionesoinformacion@gmail.com" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-177" data-mp="wp4n3ucw0ccb">
              📧 solucionesoinformacion@gmail.com
            </a>
          </li>
          <li data-id="element-178" data-mp="90lflh1nw3la">
            <a href="https://instagram.com/metodofutboldigital" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-179" data-mp="9039ztt40d0p">
              📱 @metodofutboldigital
            </a>
          </li>
          <li data-id="element-180" data-mp="6mbjw3hbzutd">
            <a href="https://metodofutboldigital.shop" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-181" data-mp="6nw3iy23xtcg">
              🌐 metodofutboldigital.shop
            </a>
          </li>
        </ul>
        <p className="mt-8 text-xs text-subtle" data-id="element-182" data-mp="3o32zcm78unm5">
          Acceso digital inmediato · Material en PDF · Soporte por correo
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-xs leading-relaxed text-subtle" data-id="element-183" data-mp="3j51fhz1zuk9m">
          Este material es educativo y no reemplaza la asesoría de un abogado especializado en
          derecho deportivo. Los reglamentos se actualizan: verifica siempre la normativa vigente de
          FIFA y, en segundo lugar, lo que apliquen el club y la FMF, y consulta con un profesional
          especializado antes de firmar.
        </p>
        <p className="mt-3 text-xs text-subtle" data-id="element-184" data-mp="1rfquztewyf9a">
          © 2026 Método para padres de futbolistas™ — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}